import { createContext, useContext, useState, type FC, type ReactNode } from 'react';

interface WorkspaceContextValue {
  workspaceId: number;
  setWorkspaceId: (id: number) => void;
}

export const WorkspaceContext = createContext<WorkspaceContextValue>({
  workspaceId: Number(localStorage.getItem('uvp_current_workspace_id') ?? '1') || 1,
  setWorkspaceId: () => {},
});

export const WorkspaceProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [workspaceId, setWorkspaceIdState] = useState<number>(
    () => Number(localStorage.getItem('uvp_current_workspace_id') ?? '1') || 1
  );

  const setWorkspaceId = (id: number) => {
    setWorkspaceIdState(id);
    localStorage.setItem('uvp_current_workspace_id', String(id));
  };

  return (
    <WorkspaceContext.Provider value={{ workspaceId, setWorkspaceId }}>
      {children}
    </WorkspaceContext.Provider>
  );
};

export const useWorkspaceId = () => useContext(WorkspaceContext);
